import React from 'react'

export default function ClientTagging({ tag }) {
  let tagStyle = ''
    if (tag == 'small') {
      tagStyle = 'grey'
    } else if (tag == 'medium') {
      tagStyle = 'green'
    } else if (tag == 'large') {
      tagStyle = 'orange'
    } else if (tag == 'vip') {
      tagStyle = 'black'
    }

  return(
    <>
      { tag &&
        <div  className='flex-box items-center content-center'
              style={{ backgroundColor: tagStyle, padding: '4px 20px', borderTopRightRadius: 30, borderBottomRightRadius: 30, borderTopLeftRadius: 6, borderBottomLeftRadius: 6, color: 'white', fontWeight: 700 }}>
          { tag.toUpperCase() }                
        </div>
      }
    </>
  )
}